import * as Yup from 'yup';

export default Yup.object().shape({
  commercialName: Yup.string().required('SCHEMA_ERRORS.VALUE_REQUIRED'),
  equipmentType: Yup.object().required('SCHEMA_ERRORS.VALUE_REQUIRED')
});
